import React from 'react';

import {
  ContactAddress,
  ContactAddressBreak,
  ContactAddressLink,
  ContactDetailsContent,
  ContactDetailsSection,
  ContactDivider,
  ContactPhoneLink,
} from './styles';

/**
 * Renders the footer contact row with address and support phone.
 */
export function ContactDetails() {
  return (
    <ContactDetailsSection about="Contact details">
      <ContactDetailsContent>
        <ContactAddress>
          <ContactAddressLink
            href="https://www.google.com/maps?q=9+Gordon+Hill,+Parktown,+Johannesburg,+2193"
            target="_blank"
            rel="noopener noreferrer"
          >
            9 Gordon Hill, Parktown, <ContactAddressBreak />
            Johannesburg, 2193
          </ContactAddressLink>
        </ContactAddress>

        <ContactDivider aria-hidden="true" />

        <ContactPhoneLink href="tel:0860995125">0860 995 125</ContactPhoneLink>
      </ContactDetailsContent>
    </ContactDetailsSection>
  );
}
